<div *ngIf="loading" class="loading">
    <loader type="page" message="Загружаем номерки..."> </loader>
</div>
<ng-container [ngSwitch]="page">
    <div class="talonpicker" [class.closing]="isClosing" #pickerContainer>
        <div class="top__row">
            <div class="empty-btn">
                <button 
                    class="btn btn-dialog-close" 
                    *ngIf="page === 'pickDateTime' && !filialFromParams.length && selectedDep" 
                    (click)="backToFil()"
                    title="Вернуться к выбору филиала"
                >
                    <img src="./assets/icons/navigation/back.svg" alt="Назад" />
                </button>
            </div>
            <div class="top__row__title">{{ (depList.length === 1 || selectedDep !== null ) ? 'Выберите дату и время': 'Выберите филиал' }}</div>
            <button class="btn btn-dialog-close" (click)="closeCalendar()" title="Закрыть">
                <img src="./assets/icons/actions/close.svg" alt="Закрыть" />
            </button>
        </div>
        <div class="top__row" *ngIf="selectedDep || depList.length === 1">
            <div 
                class="currentFilial"
            >
                <img
                    src="./assets/icons/appointments/facility-compact.svg"
                    alt=""
                    width="30px"
                    height="30px"
                />

                <ng-container *ngIf="selectedDep; else defaultFilial">
                    <ng-container *ngFor="let dep of depList">
                        <span class="defaultFilial" *ngIf="dep.keyId === selectedDep">
                            {{ dep.text }}
                        </span>
                    </ng-container>
                </ng-container>
                
                <ng-template #defaultFilial>
                    <span class="defaultFilial">
                        {{ filialFromParams && filialFromParams.length > 0
                            ? filialFromParams[0].depName || 'Выберите адрес'
                            : depList.length === 1 
                                ? depList[0].text
                                : 'Выберите адрес' 
                        }}
                    </span>
                </ng-template>
            </div>
        </div>

        <ng-template ngSwitchCase="pickFilial">
            <div 
            class="list-fil"
            *ngFor="let dep of depList"
            (click)="selectDep(dep)"
            >
            <img
                src="./assets/icons/appointments/facility.svg"
                alt=""
                width="50px"
                height="50px"
            />
            <div class="_text">{{dep.text}}</div>
            
        </div>
        </ng-template>

        <ng-template ngSwitchCase="pickDateTime">
            <mat-calendar
                *ngIf="talonListAll.length !== 0 && (depList.length === 1 || selectedDep !== null)"
                class="calendar talonpicker__calendar"
                #calendar
                [dateFilter]="dateFilter"
                [(selected)]="selectedDay"
                (selectedChange)="selectDay($event)"
                [minDate]="minDate"
                [maxDate]="maxDate"
                [headerComponent]="header"
            ></mat-calendar>

            <div 
                class="record talonpicker__record"
                *ngIf="depList.length === 1 || selectedDep !== null"
            >
                <div
                    class="record__title"
                    *ngIf="
                        !(
                            talonListFiltered.length !== 0 &&
                            talonListFiltered[0].rnumbId === null &&
                            talonListFiltered[0].intervalId === null
                        )
                    "
                >
                    Свободно на <br />
                    <span class="record__title-date"
                        >{{ selectedDayText }}
                    </span>
                </div>
                <div
                    class="record__title"
                    *ngIf="
                        talonListFiltered.length !== 0 &&
                        talonListFiltered[0].rnumbId === null &&
                        talonListFiltered[0].intervalId === null
                    "
                >
                    Вы записываетесь на <br />
                    <span class="record__title-date">{{
                        selectedDayText
                    }}</span>
                </div>

                <div class="talons__empty" *ngIf="talonListFiltered.length === 0">
                    Нет доступных номерков
                </div>

                <div
                    class="talonlist record__talonlist"
                    *ngIf="
                        (talonListFiltered.length !== 0 &&
                            talonListFiltered[0].intervalId !== null) ||
                        talonListFiltered[0]?.rnumbId !== null
                    "
                >
                    <div
                        class="talon talonlist__item"
                        [class.active]="talon === pickedTalon"
                        *ngFor="let talon of talonListFiltered"
                        (click)="openTalonModal($event, talon)"
                        [ngClass]="{
                            disabled: !talonDisable(talon)
                        }"
                    >
                        {{ talon.dtBegin | date : "HH:mm" }}
                        <!-- Подсказка только для отключённых талонов -->
                        <div *ngIf="!talonDisable(talon)" class="tooltip">
                            Номерок для другой услуги
                        </div>
                    </div>
                </div>
            </div>

            <ng-container
                *ngIf="
                    talonListFiltered.length !== 0 &&
                    talonListFiltered[0].rnumbId === null &&
                    talonListFiltered[0].intervalId === null
                "
            >
                <button
                    class="btn btn-dialog-accept"
                    (click)="openTalonModal($event, talonListFiltered[0])"
                >
                    Продолжить
                </button>
            </ng-container>
        </ng-template>

    </div>
</ng-container>
